import Mutations from '../../odata/mutations';

export default { ...new Mutations('xeroReportExpenseLineItem'), ...new Mutations('xeroReportExpenseLineItems') };
